module.exports = __webpack_public_path__ + "img/Frame 1.fbcdc5f3.png";